export const capabilities = [
  {
    id: "01",
    title: "Research & Intelligence",
    description:
      "Industry research, applied research, industry studies, technology intelligence, analytical insights and knowledge development.",
    icon: "ri-bar-chart-grouped-line",
  },
  {
    id: "02",
    title: "Media & Publications",
    description:
      "Media, journalism, industry publications, digital communication and specialized publications including Textile Today, TexSPACE Today, Muslin and other legacy and current publications.",
    icon: "ri-newspaper-line",
  },
  {
    id: "03",
    title: "Training & Capacity Development",
    description:
      "Professional, technical and innovation-focused training and capability development. Factory Skills Development (FSD), Professional Skills Development (PSD), Innovation Black Belt, InternPro, factory-level training workshops, PPI Workshops, specialized and customized corporate training.",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "04",
    title: "Consultancy & Industry Solutions",
    description:
      "Research-based consultancy, industry advisory, capability assessment, technical and operational support, innovation support and customized industry solutions.",
    icon: "ri-briefcase-line",
  },
  {
    id: "05",
    title: "Events & Global Engagement",
    description:
      "Conferences, forums, seminars, symposiums, exhibitions, competitions, awards, factory visits, international exhibition delegations and global industry engagement.",
    icon: "ri-global-line",
  },
  {
    id: "06",
    title: "Industry Promotion & Business Development",
    description:
      "Industry communication, B2B engagement, market visibility, technology and product promotion, networking and business development.",
    icon: "ri-share-line",
  },
  {
    id: "07",
    title: "Innovation & Development",
    description:
      "Practical innovation, factory transformation, innovation projects, innovation capability development and ecosystem development through Textile Today Innovation Hub (TTIH).",
    icon: "ri-lightbulb-flash-line",
  },
];